import { render, staticRenderFns } from "./file-field.vue?vue&type=template&id=b1d2507a&"
import script from "./file-field.vue?vue&type=script&lang=js&"
export * from "./file-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VAutocomplete,VSystemBar})
